//Sass
require("./scss/main.scss") ;


//React components
require("./js/components/index");

//Custom JS

require("./js/app");

import axios from "axios";
window.axios = axios;


/*

if (process.env.NODE_ENV === "production") {
  function requireAll(r) {
    r.keys().forEach(r);
  }
  requireAll(require.context("./svg/", true, /\.svg$/));
};*/
